import React, { useMemo } from 'react';
import * as THREE from 'three';

interface DRingProps {
    position: [number, number, number];
    rotation?: [number, number, number];
    color?: string;
    scale?: number;
}

const DRing: React.FC<DRingProps> = ({
    position,
    rotation = [0, 0, 0],
    color = '#cbd5e1',
    scale = 0.5
}) => {
    // Metal material
    const material = useMemo(() => new THREE.MeshStandardMaterial({
        color: color,
        metalness: 0.9,
        roughness: 0.2,
    }), [color]);

    return (
        <group position={position} rotation={rotation} scale={[scale, scale, scale]}>
            {/* Base plate on the deck */}
            <mesh position={[0, 0.01, 0]}>
                <boxGeometry args={[0.3, 0.02, 0.3]} />
                <primitive object={material} attach="material" />
            </mesh>

            {/* The D-Ring (Torus) */}
            <mesh position={[0, 0.1, 0]} rotation={[Math.PI / 2, 0, 0]}>
                <torusGeometry args={[0.08, 0.02, 16, 32, Math.PI]} />
                <primitive object={material} attach="material" />
            </mesh>

            {/* Ring pivots/holders */}
            <mesh position={[-0.08, 0.05, 0]}>
                <cylinderGeometry args={[0.02, 0.02, 0.1]} />
                <primitive object={material} attach="material" />
            </mesh>
            <mesh position={[0.08, 0.05, 0]}>
                <cylinderGeometry args={[0.02, 0.02, 0.1]} />
                <primitive object={material} attach="material" />
            </mesh>
        </group>
    );
};

export default DRing;
